import classNames from "classnames";
import { FC, useMemo } from "react";

import Modal from "components/Modal";
import ModalUserContent from "./Content";

import { getModalCallbacks } from "store/slices/modalCallbacksRegistry";

import { UserFormValues } from "entities/companies";

import styles from "./style.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  withCompanySelect?: boolean;
  type?: "add" | "edit";
  callbackKey?: string;
  data?: UserFormValues;
};

const WidgetModalUser: FC<PropTypes> = ({ isVisible, className, withCompanySelect, type, data, callbackKey }) => {
  const callbacks = useMemo(() => (callbackKey ? getModalCallbacks(callbackKey) : undefined), [callbackKey]);
  const onSubmit = useMemo(() => callbacks?.onSave, [callbacks]);

  return (
    <Modal
      title={type === "add" ? "Invite User" : "Edit User"}
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <ModalUserContent withCompanySelect={withCompanySelect} type={type} data={data} onSubmit={onSubmit} />
    </Modal>
  );
};

export default WidgetModalUser;
